import * as React from "react"
import { cn } from "src/lib/utils"

const sizeVariants = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12"
}

const Spinner = React.forwardRef(({ className, size = "md", ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "animate-spin rounded-full border-2 border-muted border-t-primary",
        sizeVariants[size],
        className
      )}
      {...props}
    />
  )
})

Spinner.displayName = "Spinner"

export { Spinner }